import { Input, FormProps } from 'antd';

import Form from './Form';

export interface OAuthClientFormValues {
  clientName: string;
  publicKey: string;
}

const OAuthClientForm = ({ ...props }: FormProps) => {
  return (
    <Form<OAuthClientFormValues> {...props}>
      <Form.Item label="Nome" name="clientName" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Chave pública" name="publicKey" rules={[{ required: true }]}>
        <Input.TextArea autoSize={{ minRows: 5, maxRows: 12 }} />
      </Form.Item>
    </Form>
  );
};

export default OAuthClientForm;
